import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function ResidenceFinanceDetails({ residence, expectedPayment, totalPaid }) {
  return (
    <Col className="residence-finance-details">
      <h5 className="mb-3 mt-4">Detalle financiero al momento</h5>
      <Row>
        <Col>
          <h6>Balance inicial</h6>
        </Col>
        <Col>
          <h6>Descuento anual</h6>
        </Col>
        <Col>
          <h6>Acumulado de pagos</h6>
        </Col>
        <Col>
          <h6>Pago pendiente</h6>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>${residence.starting_balance.toFixed(2)}</p>
        </Col>
        <Col>
          <p>${residence.discount.toFixed(2)}</p>
        </Col>
        <Col>
          <p>${totalPaid.toFixed(2)}</p>
        </Col>
        <Col>
          <p>${(expectedPayment - totalPaid).toFixed(2)}</p>
        </Col>
      </Row>
    </Col>
  );
}

export default ResidenceFinanceDetails;
